import Create from './create'
import Edit from './edit'

export { Create, Edit }



// WEBPACK FOOTER //
// ./src/pages/widgets/mosaic/index.js